export const COMPONENT_NAME = "history-table";
